import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { lighten } from "polished";

export const MobileDrawerContainer = styled.div<{ anchor: "left" | "right" }>`
  position: fixed;
  top: 0;
  ${props => props.anchor}: 0;
  bottom: 0;
  padding: 16px 0;
  background: ${props => props.theme.colors.primary};
  box-shadow: 2px 0px 6px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
`;

export const IconWrapper = styled.div`
  img {
    margin: 1rem 0;
    padding: 0 18px;
    user-select: none;
  }
`;

export const LinkBar = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  &.linkbar--top {
    flex: 1;
  }
`;

const linkBarItemStyle = css`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 200ms ease;

  &:focus,
  &:hover {
    background: ${({ theme }) =>
      theme.colors.isLight
        ? lighten(0.04, theme.colors.primary)
        : `rgba(0,0,0,.15)`};
  }
`;

export const LinkBarItem = styled.div`
  ${linkBarItemStyle}
  cursor: pointer;
`;
export const LinkBarExternalLink = styled.a`
  ${linkBarItemStyle}
`;
export const LinkBarInternalLink = styled(Link)`
  ${linkBarItemStyle}
`;
